import { brandPrimary, mention } from '../../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		background: mention,
		border: `2px dashed ${brandPrimary}`,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: '20px 30px 30px',
		position: 'relative',
		textAlign: 'center',
	},
	text: {
		color: brandPrimary,
		fontSize: 20,
		lineHeight: 1.5,
	},
});
